import React, { useEffect, useState } from 'react';
import { Image as RBImage } from 'react-bootstrap';

/**
 * Safe image that never passes "" to `src`.
 * - Uses `placeholder` when `src` is empty/invalid
 * - Swaps to placeholder on load error
 * - If both are missing, renders nothing.
 */
export default function SmartImage({
  src,
  alt = '',
  placeholder = null,     // e.g. "/placeholder-product.png" if you have it in /public
  ...props
}) {
  const sanitize = (val) =>
    typeof val === 'string' && val.trim().length > 0 ? val.trim() : null;

  const [resolved, setResolved] = useState(() => sanitize(src) || sanitize(placeholder));

  useEffect(() => {
    setResolved(sanitize(src) || sanitize(placeholder));
  }, [src, placeholder]);

  if (!resolved) return null;

  return (
    <RBImage
      alt={alt}
      src={resolved}
      onError={() => {
        const ph = sanitize(placeholder);
        if (ph && resolved !== ph) setResolved(ph);
        else setResolved(null);
      }}
      {...props}
    />
  );
}